import { Component, OnInit, ElementRef, NgZone, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
//import { NetworkServicesService } from 'src/app/networkCalls/network-services.service';
import { Title, Meta } from '@angular/platform-browser';
// import { katanaInput } from 'src/app/models/katana-input.service';
// import { katanaResult } from 'src/app/models/katana-result.service';
// import { CKEditorComponent } from 'ngx-ckeditor';
import { isPlatformBrowser, DOCUMENT, isPlatformServer } from '@angular/common';
// import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';
// import { Observable, from } from 'rxjs';
// import { MatDialog } from '@angular/material';
// import { ErrorModalComponent } from '../error-modal/error-modal.component';
// import { ProgressStatusService } from '../../services/progress-status-service'
//import { rejectError } from 'src/app/models/reject-suggetions.service';
// import { NGXLogger } from 'ngx-logger';
//import { acceptError } from 'src/app/models/accept-suggetions.service';
//import { trigger, transition, style } from '@angular/animations';
// import { $ } from 'protractor';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from 'src/app/_services/analytics.service';
//import { MatRadioChange } from '@angular/material/radio';
//import { MatSnackBar } from '@angular/material/snack-bar';
//import { start } from 'repl';
// import { MatDialog } from '@angular/material/dialog';
// import { NoopScrollStrategy } from '@angular/cdk/overlay'
// import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
// import { EnglishGrammarCheckerComponent } from 'src/app/Components/english-grammar-checker/english-grammar-checker.component';
// import { environment } from 'src/environments/environment';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-gc-editor',
  templateUrl: './gc-editor.component.html',
  styleUrls: ['./gc-editor.component.scss']
})
export class GcEditorComponent implements OnInit {
  activeSlide = 0;
  trinkaCloudUrl = environment.trinkaCloudUrl;
  constructor(
    private elRef: ElementRef,
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    // public dialog: MatDialog,
    // public progressStatusService: ProgressStatusService,
    // private errorModalComponent: ErrorModalComponent,
    public lc: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private analyticsService: AnalyticsService
    // private logger: NGXLogger,
  ) {
    //window.addEventListener("message", (d)=>{this.listenWindowMessage(d)});
  }


  ngOnInit() {
    // ele.classList.remove("loading")
    this.titleService.setTitle("Free Grammar Checker: Get Grammar Checks in Seconds");
    this.metaTagService.updateTag({ name: 'description', content: "Grammar Checker for free. Fix all grammar, spelling, and punctuation errors with Trinka grammar checker tool. Paste your text and hit the check grammar button. No sign-up needed." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Free Grammar Checker: Get Grammar Checks in Seconds" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Grammar Checker for free. Fix all grammar, spelling, and punctuation errors with Trinka grammar checker tool. Paste your text and hit the check grammar button. No sign-up needed." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.addTag({ property: 'og:image:alt', content: 'Grammar Checker' });
    this.metaTagService.addTag({ property: 'og:site_name', content: 'Grammar Checker: Trinka AI' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Free Grammar Checker: Get Grammar Checks in Seconds' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Grammar Checker for free. Fix all grammar, spelling, and punctuation errors with Trinka grammar checker tool. Paste your text and hit the check grammar button. No sign-up needed." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:url', content: 'https://www.trinka.ai/grammar-checker' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'grammar checker, free grammar checker, best grammar checker free, grammar checker online free, best grammar checker online, ai grammar checker, free ai grammar checker' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/grammar-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/corrector-gramatical' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/grammar-checker' });
    //this.LinkService.addTag({ rel: 'alternate', hreflang: 'de-de', href: 'https://www.trinka.ai/de/grammatik-pruefen' });
    if (isPlatformBrowser(this.platformId)) {
      if ((navigator.userAgent.indexOf("Edg") != -1)) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "block");
        return 'Edge';
      }
      else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "block");
        return 'IE';
      }
      else if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");
        return 'Opera';

      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        $("#GCChromeButton").css("display", "block");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");
        return 'Chrome';

      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");

        return 'Safari';

      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "block");
        $("#GCEdgeButton").css("display", "none");
        return 'Firefox';

      }
      else {
        return 'unknown';
      }

    }

    if (isPlatformServer(this.platformId)) {
      const script = this._renderer2.createElement('script');
      script.type = 'application/ld+json';
      script.text = `{"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI: Free Grammar Checker","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"Grammar Checker","item":"https://www.trinka.ai/grammar-checker"}]}`
      this._renderer2.appendChild(this._document.head, script);

      const script2 = this._renderer2.createElement('script');
      script2.type = 'application/ld+json';
      script2.type = `{"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"How does Trinka's AI Grammar Checker work?","acceptedAnswer":{"@type":"Answer","text":"Trinka's AI Grammar Checker reviews your writing for grammar, spelling, punctuation, sentence structure, and word choice issues. It analyzes each sentence in context and suggests changes that improve clarity and readability. You can review every suggestion before accepting it."}},{"@type":"Question","name":"What types of grammar mistakes can Trinka detect?","acceptedAnswer":{"@type":"Answer","text":"Trinka detects subject-verb agreement errors, verb tense issues, articles, prepositions, punctuation, spelling, capitalization, sentence fragments, run-on sentences, passive voice, word choice, and other language issues. It also suggests improvements for sentence flow and readability."}},{"@type":"Question","name":"Is Trinka's Grammar Checker free to use?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka's Grammar Checker is free to use for identifying grammar, spelling, punctuation, and language errors. Premium plans provide additional writing suggestions and advanced editing features."}},{"@type":"Question","name":"Can Trinka check academic and technical writing?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka is designed for academic and technical writing. It helps improve research papers, journal manuscripts, theses, dissertations, technical reports, and other professional documents while preserving the original meaning."}},{"@type":"Question","name":"Can Trinka check research papers and journal manuscripts?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka reviews research papers, journal manuscripts, theses, and dissertations for grammar, spelling, punctuation, and language issues. It also suggests improvements that make academic writing clearer and easier to read before submission."}},{"@type":"Question","name":"Can Trinka help improve a bachelor's, master's, or PhD thesis?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka helps improve the language quality of bachelor's, master's, and PhD theses by checking grammar, spelling, punctuation, sentence structure, and writing style before submission."}},{"@type":"Question","name":"Can Trinka Grammar Checker help improve my writing?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka does more than correct grammar mistakes. It suggests improvements for sentence structure, word choice, clarity, and readability. Many suggestions also include explanations that can help you improve your writing over time."}},{"@type":"Question","name":"Can Trinka improve writing style and readability?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka suggests improvements that enhance sentence flow, word choice, clarity, and readability while preserving your original meaning."}},{"@type":"Question","name":"Can this tool be used as a punctuation and spell checker?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka checks punctuation and spelling alongside grammar. It identifies common language issues and suggests corrections to improve writing quality."}},{"@type":"Question","name":"Where can I use Trinka's Grammar Checker?","acceptedAnswer":{"@type":"Answer","text":"You can use Trinka's Grammar Checker in the Cloud Editor, Microsoft Word, Google Chrome, Mozilla Firefox, Microsoft Edge, and the Windows app, allowing you to review your writing across multiple platforms."}},{"@type":"Question","name":"Does Trinka's Grammar Checker support both US English and UK English?","acceptedAnswer":{"@type":"Answer","text":"Yes. Trinka supports both US English and UK English. You can choose your preferred English variant, and Trinka will check spelling, grammar, punctuation, and language accordingly."}},{"@type":"Question","name":"Which languages does Trinka's Grammar Checker support?","acceptedAnswer":{"@type":"Answer","text":"Trinka offers language-specific Grammar Checker experiences for English, Japanese, Simplified Chinese, Traditional Chinese, Korean, Spanish, and Portuguese, helping users improve writing quality across multiple languages."}},{"@type":"Question","name":"Are there better alternatives to Grammarly and QuillBot Grammar Checker?","acceptedAnswer":{"@type":"Answer","text":"Different grammar checkers are designed for different writing needs. Trinka is an AI-powered alternative that offers grammar checking, style improvements, and writing enhancement features for academic, technical, and professional writing. The best choice depends on your writing requirements."}},{"@type":"Question","name":"What other writing and editing tools does Trinka provide besides Grammar Checker?","acceptedAnswer":{"@type":"Answer","text":"In addition to Grammar Checker, Trinka offers tools such as the Paraphrasing Tool, Journal Finder, AI Detector, Punctuation Checker, Spell Checker, Sentence Checker, Essay Checker, Medical Grammar and Spelling Checker, Academic Phrasebank, Thesis Checker, AI Editing, and Free Proofreading Tools to help improve writing quality."}}]}`;
      this._renderer2.appendChild(this._document.head, script2);

      const script3 = this._renderer2.createElement('script');
      script3.type = 'application/ld+json';
      script3.text = `{"@context":"https://schema.org","@type":"WebPage","@id":"https://www.trinka.ai/grammar-checker#webpage","name":"Grammar Checker","url":"https://www.trinka.ai/grammar-checker","description":"Grammar Checker for free. Fix all grammar, spelling, and punctuation errors with Trinka grammar checker tool. Paste your text and hit the check grammar button. No sign-up needed.","inLanguage":"en","isPartOf":{"@type":"WebSite","@id":"https://www.trinka.ai/"}}`
      this._renderer2.appendChild(this._document.head, script3);

      const script5 = this._renderer2.createElement('script');
      script5.type = 'application/ld+json';
      script5.type = `{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.trinka.ai/grammar-checker#webpage","url":"https://www.trinka.ai/grammar-checker","name":"Grammar Checker","description":"Trinka Grammar Checker is an AI-powered online grammar checker and writing assistant that helps improve grammar, spelling, punctuation, clarity, style, and tone. Designed for everyday, business, academic, and technical writing, it provides advanced proofreading, context-aware language suggestions, consistency checks, vocabulary enhancements, and publication-ready writing support for students, professionals, researchers, educators, and enterprises.","inLanguage":"en","isPartOf":{"@id":"https://www.trinka.ai/#website"},"about":{"@id":"https://www.trinka.ai/#grammar-checker-tool"},"mainEntity":{"@id":"https://www.trinka.ai/#grammar-checker-tool"}},{"@type":"SoftwareApplication","@id":"https://www.trinka.ai/#grammar-checker-tool","name":"Trinka Grammar Checker","url":"https://www.trinka.ai/grammar-checker","applicationCategory":"BusinessApplication","applicationSubCategory":"Grammar Checker","operatingSystem":["Web","Windows"],"softwareRequirements":["Modern Web Browser","Microsoft Word","Google Chrome","Mozilla Firefox","Microsoft Edge"],"publisher":{"@id":"https://www.trinka.ai/#organization"},"creator":{"@id":"https://www.trinka.ai/#organization"},"isPartOf":{"@id":"https://www.trinka.ai/#software"},"description":"Trinka Grammar Checker is an AI-powered online grammar checker and writing assistant that helps improve grammar, spelling, punctuation, clarity, style, and tone. Designed for everyday, business, academic, and technical writing, it provides advanced proofreading, context-aware language suggestions, consistency checks, vocabulary enhancements, and publication-ready writing support for students, professionals, researchers, educators, and enterprises.","availableLanguage":["English","Spanish"],"featureList":["Grammar Checking","Spelling Checking","Punctuation Checking","Writing Clarity Enhancement","Style Suggestions","Tone Suggestions","Vocabulary Enhancement","Sentence Structure Improvement","Context-Aware Language Suggestions","Proofreading Assistance","Consistency Checks","Academic Writing Assistance","Technical Writing Assistance","Business Writing Assistance","Publication-Ready Writing Support","US English Support","UK English Support","Power Mode","Lite Mode"],"audience":[{"@type":"Audience","audienceType":"Students"},{"@type":"Audience","audienceType":"Researchers"},{"@type":"Audience","audienceType":"Academics"},{"@type":"Audience","audienceType":"PhD Scholars"},{"@type":"Audience","audienceType":"Educators"},{"@type":"Audience","audienceType":"Professionals"},{"@type":"Audience","audienceType":"Technical Writers"},{"@type":"Audience","audienceType":"Medical Writers"},{"@type":"Audience","audienceType":"Businesses"},{"@type":"Audience","audienceType":"Enterprises"}]}]}`;
      this._renderer2.appendChild(this._document.head, script5);

      const script6 = this._renderer2.createElement('script');
      script6.type = 'application/ld+json';
      script6.text = `{"@context":"https://schema.org","@type":"HowTo","name":"How to Use Trinka's AI Grammar Checker?","description":"Learn how to use Trinka's free AI-powered grammar checker to fix spelling, grammar, and sentence structure in 4 easy steps.","image":{"@type":"ImageObject","url":"https://www.trinka.ai/images/grammar-checker-og.png"},"totalTime":"PT2M","supply":[],"tool":[{"@type":"HowToTool","name":"Trinka Grammar Checker"}],"step":[{"@type":"HowToStep","url":"https://www.trinka.ai/grammar-checker#step1","name":"Type or Paste the Text","itemListElement":[{"@type":"HowToDirection","text":"You can either type your content directly into the Trinka editor or copy and paste your text from your document."}]},{"@type":"HowToStep","url":"https://www.trinka.ai/grammar-checker#step2","name":"Click 'Check Grammar'","itemListElement":[{"@type":"HowToDirection","text":"Click the 'Check Grammar' button. Our AI engine will scan your text for grammatical mistakes, punctuation errors, and style issues."}]},{"@type":"HowToStep","url":"https://www.trinka.ai/grammar-checker#step3","name":"Review Suggestions","itemListElement":[{"@type":"HowToDirection","text":"Review the highlighted suggestions. Click on any suggestion to see the explanation and accept the correction automatically."}]},{"@type":"HowToStep","url":"https://www.trinka.ai/grammar-checker#step4","name":"Copy and Use the Revised Text","itemListElement":[{"@type":"HowToDirection","text":"Once you are satisfied with the improvements, copy the revised text to use in your final document."}]}]}`
      this._renderer2.appendChild(this._document.head, script6);
    }

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  selectedTab: 'english' | 'spanish' = 'english';

  selectTab(tab: 'english' | 'spanish'): void {
    this.selectedTab = tab;
  }

  ngAfterViewInit() {
    const observer = new MutationObserver(() => {
      const editors = document.querySelectorAll('.editor');
  
      editors.forEach((editor) => {
        editor.setAttribute('data-gramm', 'false');
        editor.setAttribute('data-gramm_editor', 'false');
        editor.setAttribute('data-enable-grammarly', 'false');
      });
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    $('#snippetSlider').on('slid.bs.carousel', (event: any) => {

      this.activeSlide = event.to;
  
      const announcer = document.getElementById('testimonial-announcer');
  
      if (announcer) {
  
        announcer.textContent = '';
  
        setTimeout(() => {
          announcer.textContent =
            `Showing testimonial ${this.activeSlide + 1} of ${this.testimonials.length}`;
        }, 100);
  
      }
  
    });

    setTimeout(() => {
      const feedback = document.querySelector(
        'lib-multilingual-editor-marketing .feedback'
      ) as HTMLElement;
  
      if (!feedback) return;
  
      feedback.setAttribute('role', 'button');
      feedback.setAttribute('tabindex', '0');
  
      feedback.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          feedback.click();
        }
      });
    });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  handleTabChange(lang: string) {
    if (lang === 'english') {
      document.getElementById('englishTab')?.click();
    } else if (lang === 'spanish') {
      document.getElementById('spanishTab')?.click();
    }
  
    // scroll to section
    document.getElementById('grammarTabs')?.scrollIntoView({
      behavior: 'smooth'
    });
  }

  buildPlanCheckoutUrl(
    planType: string,
    opts: {
      coupon?: string;
      utm_source?: string;
      utm_medium?: string;
      utm_campaign?: string;
      utm_id?: string;
    } = {}
  ) {
    const {
      coupon,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_id
    } = opts;
  
    const payload = {
      frmktg: true,
      go_to_payments: true,
      plan_type: planType,
      planType: planType,
      plan_name: 'basic'
    };
  
    const encoded = btoa(
      encodeURIComponent(JSON.stringify(payload))
    ).replace(/=/g, '');
  
    const params = new URLSearchParams();
  
    if (coupon) params.set('cp', coupon);
    if (utm_source) params.set('utm_source', utm_source);
    if (utm_medium) params.set('utm_medium', utm_medium);
    if (utm_campaign) params.set('utm_campaign', utm_campaign);
    if (utm_id) params.set('utm_id', utm_id);
  
    const query = params.toString();
  
    return `${environment.paymentsUrl}/user/${encoded}${query ? `?${query}` : ''}`;
  }

  trackGrammarCheckerClick() {
    this.analyticsService.trackEvent('grammar_checker_click', {
      event_category: 'CTA',
      event_label: 'Try for Free — No Signup Required',
      page: 'grammar-checker'
    });
  }

  testimonials = [
    {
      "author": "Hugo Alberto Rivera Rodriguez",
      "designation": "Assistant Professor, Colombia",
      "message": "Trinka made my published papers read better. It helped me find the right journals for my work.",
      "photo": "clientPhotos/hugo.webp"
    },
    {
      "author": "Raquel Rodrigues",
      "designation": "PhD student, Brazil",
      "message": "The platform helped me with grammar and flow. I also use it to check my references.",
      "photo": "clientPhotos/raquel_rodrigues.jpg"
    },
    {
      "author": "Dr. Maryam Razmgir",
      "designation": "Associate Professor, Iran",
      "message": "Trinka helped me fix my grammar and improve my writing. It is good to work with.",
      "photo": "clientPhotos/maryam.png"
    },
  ]
  

}
